// React and related hooks
import React, { useMemo, useState, useEffect, Children, useRef } from "react";
import { useNavigate } from "react-router";

// React Table
import { useTable } from "react-table";

// API
import middleware from "../../../Api/Middleware";

// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";

// CSS
import "../css/AddProductPages.css";
import "../../../Main/Main.css";
import "../../product.css";
import "../css/UploadArea.css";

// Components
import TablePreset from "../../../Table/TablePreset";
import ToastError from "../../../Toasts/ToastError";
import ToastSuccess from "../../../Toasts/ToastSuccess";
import NavbarIcon from "../../../Navbars/Sidebar/Icons/globe.png";
import PriceBox from "../edit/edit_components/boxPrice";
import MediaUploaderComponent from "../../../MediaUpload/MediaUploaderComponent";
import Categories from "../sub_components/Categories";
import FirstBox from "../edit/edit_components/boxfirst";
import { BorderedSquareTextInput,BorderedSquareNumberInput, BorderedMoneyInput, RegularSquareMoneyInput, RegularMoneyInput } from "../../../HouseStyle/Components/Inputs";
import CurrencyInput from "react-currency-input-field";
import PageTemplate from "../../../Templates/PageTemplate";
import Backbutton from "../images/BackIcon.svg";
import { BackButton, ButtonBlue, ButtonDarkBlue } from "../../../HouseStyle/Components/Buttons";
import { RegularCheckBox } from "../../../HouseStyle/Components/Checkboxes";
import { use } from "react";
import { all } from "axios";
import { add } from "lodash";
import SalesChannelsBox from "../sub_components/SalesChannelsBox";
import Modals from "../.././subpages/sub_components/VariationModals";
import LoadingIcon from "../../../HouseStyle/Components/LoadingIcon";
import LoadingScreen from "../../../LoadingScreen/LoadingScreen";
import { formatCurrency } from "../../../../utils";
import RelatedProductsBox from "../sub_components/RelatedProductsBox";
import ShippingInfoBox from "../edit/edit_components/ShippingInfoBox";
import ConfirmationModal from "../../../Modals/ConfirmationModal";

const AddVariation = (props) => {
  const navigate = useNavigate();

  // Pagination
  const [pagination, setPagination] = useState({
    page_size: 10,
    page: 1,
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  });

  // Loading state
  const [isLoading, setIsLoading] = useState(true);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [addColorOpen, setAddColorOpen] = useState(false);
  const [refetch, setRefetch] = useState(false);

  // barcode overwrite confirmation
  const [showGenerateConfirm, setShowGenerateConfirm] = useState(false);
  const [pendingGenerateId, setPendingGenerateId] = useState(null);
  const [pendingBulkGenerate, setPendingBulkGenerate] = useState(false);
  const [pendingBulkGenerateIds, setPendingBulkGenerateIds] = useState([]);

  const maxBarcodeLength = 25;
  // Products info
  const [values, setValues] = useState({
    product_name: "",
    product_number: "",
    type: 2,
    weight: "",
    length: "",
    width: "",
    height: ""
  });
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState(true);
  const [buttonPressed, setbuttonPressed] = useState(null);
  const [brandId, setBrandId] = useState("");
  const [taxClass, setTaxClass] = useState(1);
  const [selectedTax, setSelectedTax] = useState(null);
  const [taxSettings, setTaxSettings] = useState(null);
  const [duplicateInstalled, setDuplicateInstalled] = useState(JSON.parse(localStorage.getItem("appstore")));
  const [productMeasurementsInstalled, setProductMeasurementsInstalled] = useState(() => {
    const appstore = JSON.parse(localStorage.getItem("appstore"));
    return appstore?.apps?.find(app => app.slug === "product-measurements")?.status === 3;
  });
  const [stock, setStock] = useState({});

  // Categories
  const [categories, setCategories] = useState([]);

  // Brands, genders, sales Channels
  const [brands, setBrands] = useState([]);
  const [genders, setGenders] = useState([]);
  const [salesChannels, setSalesChannels] = useState([]);
  const [selectedSalesChannels, setSelectedSalesChannels] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [selectedSeasons, setSelectedSeasons] = useState([]);
  const [product, setProduct] = useState([{}]);

  // Variations
  const [variations, setVariations] = useState([]);
  const [allVariations, setAllVariations] = useState([]);
  const [selectedVariationIds, setSelectedVariationIds] = useState([]);
  const [colorVariations, setColorVariations] = useState([]);
  const [sizeVariations, setSizeVariations] = useState([]);
  const [allSizes, setAllSizes] = useState([]);
  const [allColors, setAllColors] = useState([]);

  const [addVariation, setAddVariation] = useState({
    size: "",
    color: "",
  });
  const [variationSwitch, setVariationSwitch] = useState(false);

  const [colorFilter, setColorFilter] = useState("");
  const [sizeFilter, setSizeFilter] = useState("");

  // Images
  const [images, setImages] = useState([]);
  const [updatedMedia, setUpdatedMedia] = useState(false);
  const [requiredCheck, setRequiredCheck] = useState(false);

  // selection
  const [selectedIds, setSelectedIds] = useState([]);
  const [initialCategories, setInitialCategories] = useState([
    { primary_key: 1, id: 1, headId: null, name: "Categories" },
  ]);

  const [initialCategoriesNew, setInitialCategoriesNew] = useState([
    { primary_key: 1, id: 1, headId: null, name: "Categories" },
  ]);

  const organizeCategory = (categories, parentId = null) => {
    return categories
      .filter((category) => category.headId === parentId)
      .map((category) => {
        return {
          ...category,
          subcategories: organizeCategory(categories, category.id),
        };
      });
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryNew, setSearchQueryNew] = useState("");
  const [checkedCategories, setCheckedCategories] = useState({});
  const [categoryTree, setCategoryTree] = useState(
    organizeCategory(initialCategories)
  );
  const [categoryTreeNew, setCategoryTreeNew] = useState(
    organizeCategory(initialCategoriesNew)
  );
  const [filteredCategory, setFilteredCategory] = useState(categoryTree);
  const [filteredCategoryNew, setFilteredCategoryNew] =
    useState(categoryTreeNew);
  const [tax, setTax] = useState("0");
  const [prices, setPrices] = useState([]);
  const [priceMargin, setPriceMargin] = useState();

  const slugify = (s) => {
    if (!s && s !== 0) return "";
    return String(s)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-_]/g, "");
  };

  const getBaseProductNumber = () => {
    if (values?.product_number && String(values.product_number).trim() !== "") {
      return slugify(values.product_number);
    }
    return slugify(values.product_name || "");
  };

  const buildVariationProductNumber = (base, colorName, sizeName) => {
    const editAppInstalled =
      duplicateInstalled?.apps?.find((app) => app.slug === "variabel-product-number")?.status === 3;
    if (!base) return editAppInstalled ? "" : "-";

    const parts = [];
    if (base) parts.push(base);
    if (colorName) parts.push(slugify(colorName));
    if (sizeName) parts.push(slugify(sizeName));
    return parts.filter(Boolean).join("-");
  };

  const lastBaseRef = useRef(getBaseProductNumber());

  useEffect(() => {
    const newBase = getBaseProductNumber();
    if (newBase === lastBaseRef.current) return;
    setAllVariations((prev) =>
      prev.map((v) => {
        const colorSlug = slugify(v.color_name || "");
        const sizeSlug = slugify(v.size_name || "");
        const newPN = buildVariationProductNumber(newBase, v.color_name, v.size_name);

        if (
          !v.product_number ||
          v.product_number === "-" ||
          (colorSlug && v.product_number.includes(colorSlug)) ||
          (sizeSlug && v.product_number.includes(sizeSlug))
        ) {
          return {
            ...v,
            product_number: newPN,
          };
        }

        return v;
      })
    );
    lastBaseRef.current = newBase;
  }, [values.product_name, values.product_number]);

  const fetchAll = async () => {
    setIsLoading(true);
    const [
      fetchCategories,
      fetchBrands,
      fetchGenders,
      fetchSalesChannels,
      fetchSizes,
      fetchColors,
      fetchSeasons,
    ] = await Promise.all([
      middleware.get(`products/category`),
      middleware.get(`products/brands?status=1`),
      middleware.get(`products/genders`),
      middleware.get("saleschannels?status=1"),
      middleware.get(`products/sizes`),
      middleware.get(`products/colors`),
      middleware.get("products/seasons?status=1"),
    ]);
    const cat = fetchCategories.data.data.map((map) => {
      return {
        primary_key: map.primary_key,
        id: map.category_id,
        headId: map.head_category_id,
        name: map.title,
      };
    });
    setInitialCategories(cat);
    setInitialCategoriesNew(cat);
    setCategories(fetchCategories.data.data);
    setBrands(fetchBrands.data.data);
    setGenders(fetchGenders.data.data);
    setSalesChannels(fetchSalesChannels.data.data);
    setAllSizes(fetchSizes.data.data);
    setAllColors(fetchColors.data.data);
    setSeasons(fetchSeasons.data.data || []);
    setLoadingScreenFunc();
  };
  const blobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        const commaIndex = reader.result.indexOf(',');
        resolve(reader.result.substring(commaIndex + 1));
      };
      reader.onerror = (error) => reject(error);
    });
  const validateImages = async () => {
    //Check if there are any images that are faulty (like too big or unsupported file type)
    // let faultyImages = false;
    // for (let index = 0; index < images.length; index++) {
    //   const CurrentImage = images[index];
    //   if (CurrentImage.error) {
    //     faultyImages = true;
    //   }
    // }

    const faultyImages=images.some(img=>img.error);
    let everythingFilledIn = true;
    //Check if every file has a color assigned to it
    for (let index = 0; index < images.length; index++) {
      const CurrentImage = images[index];
      if (CurrentImage.colorId === undefined) {
        everythingFilledIn = false;
      }
    }
    if (
      images.find((e) => {
        return (
          images.filter(
            (j) =>
              (e.colorId != null && j.colorId === e.colorId) ||
              (e.sizeId != null && j.sizeId === e.sizeId)
          ).length > 3
        );
      })
    ) {
      // check if its not id 0
      if (
        images.find(
          images.filter((j) => j.colorId !== 0 || j.sizeId !== 0).length > 3
        )
      ) {
        return "Je mag maar 3 images per variatie toevoegen.";
      }
    }
    //If there are any images that are faulty, a pop-up will appear and will stop the code from running any further
    if (faultyImages) {
      return "Verwijder de foto's die ongeldig zijn voordat je opslaat.";
    }
    // If there are any images that have no color assigned to them, a pop-up will appear and will stop the code from running any further
    else if (!everythingFilledIn) {
      return "Vul alle kleuren/maten in!";
    }
    return true;
  };
  const saveImages = async (productID) => {
    try {
      let currentProductId = productID;
      const currentMonth = (new Date().getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const currentYear = new Date().getFullYear();
      const folderPath = `warehouse/uploads/${currentYear}/${currentMonth}/${currentProductId}`;

      //The string with all the data that will be send to the API so it saves the image path, order and color
      let bulkDataString = "";
      let imagestrings = [];

      //Loop through the images and preparing them to upload
      for (let index = 0; index < images.length; index++) {
        const CurrentImage = images[index];
        const base64String = await blobToBase64(CurrentImage.file);
        imagestrings.push(base64String);

        //Add the data to the bulkdata that will eventually be sent to the middleware API
        bulkDataString += `${CurrentImage.name}|${CurrentImage.colorId
          }|${folderPath}/${CurrentImage.name.replace(/\s/g, "_")}|${index + 1}|${CurrentImage.sizeId
          }`;
        if (index < images.length - 1) {
          bulkDataString += ",";
        }
      }
      // Post request to the middleware api to save the image data to the database and delete the older information
      await middleware.post(
        `products/media/upload?product_id=${currentProductId}&bulk_data=${encodeURIComponent(
          bulkDataString
        )}`,
        { imagestrings: imagestrings }
      );

      return true;
    } catch (error) {
      // When something goes wrong the user gets logged out and send to the login page
      return (
        error.response?.data?.Message ?? error.response?.data?.error ?? false
      );
    }
  };

  const saveSeasons = async (productID) => {
    try {
      if (selectedSeasons.length > 0) {
        const bulkData = selectedSeasons.map(seasonId => ({
          product_id: productID,
          season_id: seasonId
        }));

        await middleware.post(`products/hasseasons`, {
          bulk_data: bulkData
        });
      }
      return true;
    } catch (error) {
      console.error("Error saving seasons:", error);
      return false;
    }
  };

  useEffect(() => {
    setFilteredCategory(categoryTree);
  }, [categoryTree]);

  useEffect(() => {
    setFilteredCategoryNew(categoryTreeNew);
  }, [categoryTreeNew]);

  useEffect(() => {
    filterCategory(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    filterCategoryNew(searchQueryNew);
  }, [searchQueryNew]);

  useEffect(() => {
    fetchAll();
  }, []);

  const handleFormKeyDown = (e) => {
    if (e.key !== 'Enter') return;

    const tag = (e.target?.tagName || '').toLowerCase();

    const inputType = e.target.type || '';
    if (tag === 'button' && inputType === 'submit') return;
    if (tag === 'input' && inputType === 'submit') return;

    if (tag === 'input' || tag === 'select') {
      e.preventDefault();
    }
  };

  useEffect(() => {
    filterCategory();
  }, [initialCategories]);

  useEffect(() => {
    filterCategoryNew();
  }, [initialCategoriesNew]);

  const validate = (e) => {
    e.target.checkValidity();
    e.target.reportValidity();
  };

  function generateVariation()
{
    const colorsCache = localStorage.getItem("colorsAddVariationCache");
    const sizesCache = localStorage.getItem("sizesAddVariationCache");

    if (!colorsCache || !sizesCache) {
      //navigate("/producten");
      return;
    }
    // 🐒 code
    const colors = JSON.parse(colorsCache);
    const sizes = JSON.parse(sizesCache);

    const variations = [];
    if (colors.length === 0 && sizes.length > 0) {
      sizes.forEach((size) => {
        const sizeId = parseInt(size.id, 10);
        const sizeName = size.main ?? null;

        variations.push({
          id: variations.length > 0 ? Math.max(...variations.map(v => v.id)) + 1 : 1,
          size_id: sizeId,
          size_name: sizeName,
          sizes:
            size != null
              ? [
                {
                  size_id: sizeId ?? null,
                  main: sizeName ?? null,
                },
              ]
              : [],
          barcode: null,
          stock: null,
          product_number: buildVariationProductNumber(getBaseProductNumber(), null, sizeName),
        });
      });
    } else if (sizes.length === 0 && colors.length > 0) {
      colors.forEach((color) => {
        variations.push({
          id: variations.length > 0 ? Math.max(...variations.map(v => v.id)) + 1 : 1,
          color_id: color.color_id,
          color_name: color.name,
          hex: color.hex,
          colors:
            color != null
              ? [
                {
                  color_id: color?.color_id ?? null,
                  name: color?.name ?? null,
                  hex: color?.hex ?? null,
                },
              ]
              : [],
          barcode: null,
          stock: null,
          product_number: buildVariationProductNumber(getBaseProductNumber(), color.name, null),
        });
      });
    } else {
      colors.forEach((color) => {
        sizes.forEach((size) => {
          const sizeId = parseInt(size.id, 10);
          const sizeName = size.main ?? null;
          variations.push({
            id: variations.length > 0 ? Math.max(...variations.map(v => v.id)) + 1 : 1,
            color_id: color.color_id,
            color_name: color.name,
            hex: color.hex,
            colors:
              color != null
                ? [
                  {
                    color_id: color?.color_id ?? null,
                    name: color?.name ?? null,
                    hex: color?.hex ?? null,
                  },
                ]
                : [],
            size_id: sizeId,
            size_name: sizeName,
            sizes:
              size != null
                ? [
                  {
                    size_id: sizeId ?? null,
                    main: sizeName ?? null,
                  },
                ]
                : [],
            barcode: null,
            stock: null,
            product_number: buildVariationProductNumber(getBaseProductNumber(), color.name, sizeName),
          });
        });
      });
    }

    setColorVariations(colors);
    setSizeVariations(sizes);
    setAllVariations(variations);
    generateVariations(variations);
}
  useEffect(() => {
generateVariation();
  }, [navigate]);

  useEffect(() => {
    if (allVariations != null) {
      generateVariations();
    }
  }, [pagination.page_size, pagination.page, allVariations]);

  useEffect(() => {
    let filtered = allVariations ?? [];

    if (colorFilter) {
      filtered = filtered.filter(
        (v) => v.color_id === parseInt(colorFilter, 10)
      );
    }

    if (sizeFilter) {
      filtered = filtered.filter((v) => v.size_id === parseInt(sizeFilter, 10));
    }

    const totalVariations = filtered.length;
    const { page_size, page } = pagination;
    const maxPage = Math.ceil(totalVariations / page_size);
    const newPage = Math.max(1, page > maxPage ? maxPage : page);

    const begin_of_page = (newPage - 1) * page_size;
    const end_of_page = Math.min(begin_of_page + page_size, totalVariations);
    const paginated = filtered.slice(begin_of_page, end_of_page);

    setPagination((prev) => ({
      ...prev,
      page: newPage,
      max_items: totalVariations,
      begin_of_page: totalVariations === 0 ? 0 : begin_of_page + 1,
      end_of_page: end_of_page,
    }));
    setVariations(paginated);
  }, [
    allVariations,
    colorFilter,
    sizeFilter,
    pagination.page_size,
    pagination.page,
  ]);

  const generateVariations = (variations = null) => {
    variations = variations ? variations : allVariations;
    const totalVariations = variations.length;
    const { page_size, page } = pagination;
    const maxPage = Math.ceil(totalVariations / page_size);
    const newPage = Math.max(1, page > maxPage ? maxPage : page);

    const begin_of_page = (page - 1) * page_size;
    const end_of_page = Math.min(begin_of_page + page_size, totalVariations);

    const paginatedVariations = variations.slice(begin_of_page, end_of_page);

    setVariations(paginatedVariations);
  };

  const filterCategoryRecursively = (query, categories) => {
    const lowerCaseQuery = query.toLowerCase();

    return categories
      .map((category) => {
        let categoryMatches = category.name
          .toLowerCase()
          .includes(lowerCaseQuery);
        let filteredSubcategory = [];
        let includedDueToChild = false;

        if (category.subcategory) {
          filteredSubcategory = filterCategoryRecursively(
            query,
            category.subcategory
          );
          includedDueToChild = filteredSubcategory.length > 0;
        }

        if (categoryMatches || includedDueToChild) {
          return {
            ...category,
            subcategory: filteredSubcategory,
            isIncludedDueToChild: !categoryMatches && includedDueToChild,
          };
        }

        return null;
      })
      .filter(Boolean);
  };

  const filterCategoryRecursivelyNew = (query, categories) => {
    const lowerCaseQuery = query.toLowerCase();

    return categories
      .map((category) => {
        let categoryMatches = category.name
          .toLowerCase()
          .includes(lowerCaseQuery);
        let filteredSubcategory = [];
        let includedDueToChild = false;

        if (category.subcategory) {
          filteredSubcategory = filterCategoryRecursivelyNew(
            query,
            category.subcategory
          );
          includedDueToChild = filteredSubcategory.length > 0;
        }

        if (categoryMatches || includedDueToChild) {
          return {
            ...category,
            subcategory: filteredSubcategory,
            isIncludedDueToChild: !categoryMatches && includedDueToChild,
          };
        }

        return null;
      })
      .filter(Boolean);
  };

  const Category = ({ category }) => {
    if (
      Object.keys(checkedCategories).includes(
        `1-${category.primary_key}-${category.id}-${category.headId ?? 0}`
      )
    ) {
      return (
        <div style={{ marginLeft: category.headId ? "20px" : "0px" }}>
          <div className="d-flex flex-row align-items-center ms-2">
            {category.headId != undefined && (
              <div className="lineCategories me-2"></div>
            )}
            <p className="mb-0 fw-medium"> {category.name}</p>
          </div>
          {category.subcategories && category.subcategories.length > 0 && (
            <div>
              {category.subcategories.map((sub) => (
                <Category key={sub.id} category={sub} />
              ))}
            </div>
          )}
        </div>
      );
    }
  };

  // A function to filter products.
  const filterCategory = (query) => {
    if (!query) {
      setCategoryTree(organizeCategory(initialCategories));
      return;
    }

    setCategoryTree(filterCategoryRecursively(query, initialCategories));
  };

  const filterCategoryNew = (query) => {
    if (!query) {
      setCategoryTreeNew(organizeCategory(initialCategories));
      return;
    }

    setCategoryTreeNew(
      filterCategoryRecursivelyNew(query, initialCategoriesNew)
    );
  };

  const verwerkCategorieIds = (obj) => {
    const regex = /^(\d+)-(\d+)-(\d+)$/;
    const categoryIds = [];
    const HeadIds = [];

    Object.entries(obj)
      .filter(([key, value]) => value === true && regex.test(key))
      .forEach(([key]) => {
        const match = key.match(regex);
        if (match) {
          categoryIds.push(match[2]); // Voeg het derde deel toe aan match2
          HeadIds.push(match[3]); // Voeg het vierde deel toe aan match3
        }
      });

    return {
      categoryIds,
      HeadIds,
    };
  };

  const transformData = (data) => {
    let headCategoryMap = {};

    data.HeadIds.forEach((headId) => {
      const headCategory = categories.find(
        (cat) => cat.category_id === parseInt(headId)
      );
      if (headCategory) {
        headCategoryMap[headCategory.title] = data.categoryIds
          .map((catId) => {
            const category = categories.find(
              (cat) => cat.category_id === parseInt(catId)
            );
            return category &&
              category.head_category_id === headCategory.category_id
              ? category.title
              : null;
          })
          .filter((title) => title !== null);
      }
    });

    return headCategoryMap;
  };

  const transformedData = transformData(verwerkCategorieIds(checkedCategories));

  function setLoadingScreenFunc() {
    setIsLoading(false);
    setTimeout(() => {
      setLoadingScreen(false);
    }, 500);
  }

  const handleProductSelection = (productId, isSelected) => {
    if (isSelected) {
      setSelectedVariationIds([...selectedVariationIds, productId]);
    } else {
      setSelectedVariationIds(
        selectedVariationIds.filter((id) => id !== productId)
      );
    }
  };

  const handleSelection = (id, isSelected) => {
    if (isSelected) {
      setSelectedIds((previous) => [...previous, id]);
    } else {
      setSelectedIds((previous) => previous.filter((id) => id !== id));
    }
  };

  const generateBarcode = async (event, id) => {
    if (event != null) {
      event.preventDefault();
    }

    const variation = (allVariations || []).find((v) => v.id === id) || (variations || []).find((v) => v.id === id);
    const barcodeVal = variation?.barcode?.barcode ?? (typeof variation?.barcode === 'string' ? variation.barcode : null);
    const hasBarcode = barcodeVal != null && String(barcodeVal).trim() !== "";

    if (hasBarcode) {
      setPendingGenerateId(id);
      setShowGenerateConfirm(true);
      return;
    }

    await performGenerateBarcode(id);
  };

  const performGenerateBarcode = async (id) => {
    try {
      const response = await middleware.get("products/generateBarcode");
      const newBarcode = response.data.generatedBarcode;

      handleBarcodeChange(newBarcode, id);

      if (allVariations?.length) {
        const totalVariations = allVariations.length;
        const { page_size, page } = pagination;
        const maxPage = Math.ceil(totalVariations / page_size);
        const newPage = Math.max(1, page > maxPage ? maxPage : page);

        const begin_of_page = (page - 1) * page_size;
        const end_of_page = Math.min(begin_of_page + page_size, totalVariations);

        const paginatedVariations = allVariations.slice(
          begin_of_page,
          end_of_page
        );
        setPagination({
          page_size: page_size,
          max_items: totalVariations,
          page: newPage,
          begin_of_page: totalVariations === 0 ? 0 : begin_of_page + 1,
          end_of_page: end_of_page,
        });
        setVariations(paginatedVariations);
      }
    } catch (err) {
      console.error("Fout bij genereren barcode:", err);
    }
  };

  const performBulkGenerate = async (ids = []) => {
    try {
      if (!ids || ids.length === 0) return;
      const generated = await generateMultipleBarcodes(ids.length);
      let count = 0;
      ids.forEach((selectedId) => {
        const vari = allVariations.find((v) => v.id == selectedId);
        if (!vari) {
          count++;
          return;
        }
        handleBarcodeChange(generated[count], vari.id);
        count++;
      });

      if (allVariations?.length) {
        const totalVariations = allVariations.length;
        const { page_size, page } = pagination;
        const maxPage = Math.ceil(totalVariations / page_size);
        const newPage = Math.max(1, page > maxPage ? maxPage : page);

        const begin_of_page = (page - 1) * page_size;
        const end_of_page = Math.min(begin_of_page + page_size, totalVariations);

        const paginatedVariations = allVariations.slice(
          begin_of_page,
          end_of_page
        );
        setPagination({
          page_size: page_size,
          max_items: totalVariations,
          page: newPage,
          begin_of_page: totalVariations === 0 ? 0 : begin_of_page + 1,
          end_of_page: end_of_page,
        });
        setVariations(paginatedVariations);
      }
    } catch (err) {
      console.error('Fout bij bulk genereren barcodes:', err);
    }
  };

  const generateMultipleBarcodes = async (amount) => {
    const response = await middleware.get(
      `products/generateMultipleBarcodes?barcodeAmount=${amount}`
    );
    const newBarcodes = response.data.generatedBarcode;
    return newBarcodes;
  };

  // Updated isValid function to correctly handle string and number values
  const isValid = (val) => {
    // If val is a string, we need to handle it differently than if it's a number
    if (typeof val === 'string') {
      // Trim any whitespace
      const trimmed = val.trim();
      // Check if it's empty or just "0" or "0.00"
      return trimmed !== "" && trimmed !== "0" && trimmed !== "0.00";
    }

    // If val is a number, make sure it's not 0
    if (typeof val === 'number') {
      return val !== 0;
    }

    // If val is null or undefined, it's not valid
    return val !== null && val !== undefined;
  };

  // Updated onPriceButtonClicked function with the new isValid function
  const onPriceButtonClicked = (event, variationId) => {
    const productVariation = allVariations.find((v) => v.id === variationId);
    if (!productVariation) {
      console.error(`No variation found for variationId: ${variationId}`);
      return;
    }

    const operator = event.target.innerHTML.trim(); // "+" or "-"

    setAllVariations((prev) =>
      prev.map((v) =>
        v.id === variationId ? { ...v, priceOperator: operator } : v
      )
    );
  };

  // Updated calculateFinalPrice function with the new isValid function
  const calculateFinalPrice = (variation) => {
    const pricesArray = prices ?? [];

    // Get the sale and regular prices
    const salePriceItem = pricesArray.find(item => item.type === "sale_price");
    const regularPriceItem = pricesArray.find(item => item.type === "price");

    const salePrice = salePriceItem?.incl_tax;
    const regularPrice = regularPriceItem?.incl_tax;

    // Set the base price
    let basePrice = 0;

    // First check if there's a valid sale price
    if (isValid(salePrice)) {
      basePrice = Number(salePrice);
    }
    // If no valid sale price, use the regular price
    else if (isValid(regularPrice)) {
      basePrice = Number(regularPrice);
    }

    // Extra info that has been added to the variation
    const extra = Number(variation.price?.replace(',','.')) || 0;

    // Get the operator (+ or -)
    const operator = variation.priceOperator || "+";

    // Calculate the final price
    let finalPrice = 0;
    if (operator === "+") {
      finalPrice = basePrice + extra;
    } else if (operator === "-") {
      finalPrice = basePrice - extra;

      if (finalPrice < 0) {
        ToastError("Prijs werd automatisch aangepast omdat hij negatief werd.",'negativeVal');
        finalPrice = 0;
      }
    } else {
      finalPrice = basePrice;
    }

    return finalPrice;
  };

  // Update the submitNew function in AddVariation component
  const submitNew = async (event) => {
    // Parse price values for validation
    const standardPriceObj = prices.find(p => p.type === "price");
    const salePriceObj = prices.find(p => p.type === "sale_price");
    const inclVAT = standardPriceObj && standardPriceObj.incl_tax !== undefined;
    const standardPrice = standardPriceObj ? parseFloat((inclVAT ? standardPriceObj.incl_tax : standardPriceObj.excl_tax).toString().replace(",", ".")) : null;
    const salePrice = salePriceObj ? parseFloat((inclVAT ? salePriceObj.incl_tax : salePriceObj.excl_tax).toString().replace(",", ".")) : null;
    
    event.preventDefault(); // Prevent the default form action

    if (submitting) {
      return;
    }
    setSubmitting(true);

    let newProductId = null;
    const newprices = prices.reduce((acc, curr) => {
      acc[curr.type] = {
        price_id: curr.price_id,
        incl_tax:
          typeof curr.incl_tax === "string"
            ? Number(curr.incl_tax.replace(",", ".")).toFixed(2)
            : Number(curr.incl_tax).toFixed(2),
        excl_tax:
          typeof curr.excl_tax === "string"
            ? Number(curr.excl_tax.replace(",", ".")).toFixed(2)
            : Number(curr.excl_tax).toFixed(2),
      };
      return acc;
    }, {});

    try {
      let newvariations = allVariations.map((variation) => {
        const rawPrice = Number(variation.price) || 0;
        const operator = variation.priceOperator;

        const maxBarcodeLength=25;
        if(variation.barcode && variation.barcode.length>maxBarcodeLength)
        {
          ToastError(
            "De barcode mag niet meer dan " +
              maxBarcodeLength +
              " kararakters lang zijn"
          );
          setSubmitting(false);
          return false;
        }
        const maxArticleLength = 255;
        if (variation.product_number && variation.product_number.length > maxArticleLength) {
          ToastError(`Artikelnummer mag maximaal ${maxArticleLength} karakters bevatten`);
          setSubmitting(false);
          return false;
        }

        const varBuyInPrice = variation.prices?.find(p => p.type === 'buy_in_price');

        // Ensure incl_tax is calculated from excl_tax when missing to avoid DB null insert
        let buyInPricePayload = undefined;
        if (varBuyInPrice?.excl_tax) {
          const excl = parseFloat(String(varBuyInPrice.excl_tax).replace(',', '.'));
          let incl = null;
          if (varBuyInPrice.incl_tax !== undefined && varBuyInPrice.incl_tax !== null && String(varBuyInPrice.incl_tax).trim() !== '') {
            incl = parseFloat(String(varBuyInPrice.incl_tax).replace(',', '.'));
          } else if (!isNaN(excl)) {
            const taxRate = Number(selectedTax || 0);
            incl = parseFloat((excl * (1 + taxRate / 100)).toFixed(2));
          }

          buyInPricePayload = {
            type: 'buy_in_price',
            excl_tax: excl,
            incl_tax: incl,
          };
        }

        return {
          ...(variation.barcode && { barcode: variation.barcode }),
          ...(variation.color_id && { color: variation.color_id }),
          ...(variation.stock && { stock: variation.stock }),
          ...(variation.size_id && { size: variation.size_id }),
          ...(variation.product_number != null && variation.product_number !== "" && variation.product_number !== "-" && { product_number: variation.product_number }),
          variation_price:
            operator === "+"
              ? rawPrice
              : operator === "-"
                ? -rawPrice
                : null,
          ...(buyInPricePayload && { prices: [buyInPricePayload] }),
        };
      });
      if(newvariations.some(e=>e===false)) return false;


      const validate = await validateImages();
      if (validate !== true) {
        ToastError(validate);
        setSubmitting(false);
        return false;
      }

      const productName = values.product_name;
      if (productName == null || productName.trim() == "") {
        ToastError("Product naam is verplicht");
        setSubmitting(false);
        return false;
      }

      // Only validate price relationship if both prices are filled in
      // Allow creation with no prices or only one price
      const hasValidStandardPrice = standardPrice !== null && standardPrice > 0;
      const hasValidSalePrice = salePrice !== null && salePrice > 0;
      
      if (hasValidStandardPrice && hasValidSalePrice && salePrice >= standardPrice) {
        ToastError("De kortingsprijs moet lager zijn dan de standaard prijs. Product kan nog niet worden aangemaakt.");
        setSubmitting(false);
        return false;
      }

      // Create the product
      const productResponse = await middleware.post(
        "products/create/variation",
        {
          product: {
            name: event.target.product_name?.value ?? values.product_name,
            number: event.target.product_number?.value ?? values.product_number,
            description: values.product_description,
            tax_id: taxClass,
            status: status ? 1 : 0,
            variation_type: variationSwitch,
            weight: values.weight || null,
            length: values.length || null,
            width: values.width || null,
            height: values.height || null
          },
          prices: newprices,
          stock: stock,
          variations: newvariations,
          category_ids: verwerkCategorieIds(checkedCategories).categoryIds,
          gender_ids: selectedGenders,
          brand_ids: brandId ?? null,
          sales_channel_ids: selectedSalesChannels,
        }
      );
      newProductId = productResponse.data.headProduct.product_id;
      await saveImages(newProductId);
      await saveSeasons(newProductId);
      
      // Sla tax overrides op als ze bestaan
      if (taxSettings && Object.keys(taxSettings.countryOverrides).length > 0) {
        const formattedOverrides = Object.entries(taxSettings.countryOverrides)
          .map(([countryCodeId, taxClass]) => ({
            country_code_id: parseInt(countryCodeId),
            tax_class: taxClass
          }));

        await middleware.post('products/updateTaxRates', {
          product_id: newProductId,
          global_tax_class: taxSettings.globalTaxClass,
          country_overrides: formattedOverrides
        });
      }

      ToastSuccess("Product is aangemaakt");
      localStorage.removeItem("colorsAddVariationCache");
      localStorage.removeItem("sizeId");
      localStorage.removeItem("sizesAddVariationCache");
      if (buttonPressed === 1) {
        // Reset every thing and make sure that things get refetch what doesn't want to rerendeder
        // Pagination
        setPagination({
          page_size: 10,
          page: 1,
          max_items: 0,
          begin_of_page: 0,
          end_of_page: 0,
        });


        // Products info
         setValues({
          product_name: "",
          product_number: "",
          type: 2,
          product_description:''
        });
        setStatus(true);
        setbuttonPressed(null);
        setBrandId(null);
        setStock({});

        // Brands, genders, sales Channels
        setSelectedSalesChannels([]);
        setSelectedGenders([]);
        setSelectedSeasons([]);
        setProduct([{}]);
        setRefetch(!refetch);

        // Variations
        setSelectedVariationIds([]);
        setColorVariations([]);
        setSizeVariations([]);
        setAllVariations([]);
        generateVariations([]);

        setAddVariation({
          size: "",
          color: "",
        });
        setVariationSwitch(false);
        setRequiredCheck(false)
        setSelectedTax(null);

        setColorFilter("");
        setSizeFilter("");

        // Images
        setImages([]);

        // selection
        setSelectedIds([]);

        setSearchQuery("");
        setSearchQueryNew("");
        setCheckedCategories({});
        setPrices([]);
        setPriceMargin();
      } else if (buttonPressed === 2) {
        setValues(prevValues => ({
          ...prevValues,
          product_number: ''
        }));

        const updatedVariations = allVariations.map((variation) => {
          return {
            ...variation,
            barcode: null,
            stock: null
          };
        });
        setAllVariations(updatedVariations);

        window.scrollTo(0, 0);
        setTimeout(() => {
          setbuttonPressed(null);
        }, 2000);
      } else if (buttonPressed == 3) {
        navigate("/producten/bewerken/" + newProductId);
      }
    } catch (err) {
      console.error(err);
      console.error("Fout bij product aanmaken:", err);
      console.error("Respons data:", err.response?.data); // Extra info over API-fout
      console.error("Status code:", err.response?.status); // HTTP statuscode
      console.error("Foutmelding:", err.message); // Algemene foutmelding
      ToastError("Er is een fout opgetreden bij het aanmaken van het product.");
    } finally {
      setSubmitting(false);
    }
  };

  const generate_barcodes = async () => {
      
    let filled = false;

    selectedVariationIds.forEach((selectedId) => {
      const variation = allVariations.find(
        (variation) => variation.id === selectedId || variation.id == selectedId
      );
      const barcodeVal = variation?.barcode?.barcode ?? (typeof variation?.barcode === 'string' ? variation.barcode : null);
      if (barcodeVal != null && String(barcodeVal).trim() !== "") {
        filled = true;
      }
    });

    if (filled) {
      setPendingBulkGenerate(true);
      setPendingBulkGenerateIds(selectedVariationIds.slice());
      setShowGenerateConfirm(true);
      return;
    }
    
    let count = 0;
    const generated_barcodes = await generateMultipleBarcodes(
      selectedVariationIds.length
    );
    // generate barcodes on selected fields without a barcode
    selectedVariationIds.forEach((selectedId) => {
      let vari = allVariations.find((variation) => variation.id == selectedId);
      if (vari.barcode == null || vari.barcode == "") {
        handleBarcodeChange(generated_barcodes[count], vari.id);
      }
      count++;
    });
  };

  const delete_barcodes = () => {
    // delete selected barcodes
    selectedVariationIds.forEach((selectedId) => {
      let vari = allVariations.find((variation) => variation.id == selectedId);
      if (vari.barcode != null || vari.barcode != "") {
        setAllVariations((prevVariations) =>
          prevVariations.map((variation) =>
            variation.id === vari.id
              ? { ...variation, barcode: null }
              : variation
          )
        );
        // way too much code just for a rerender :(
        if (allVariations?.length) {
          const totalVariations = allVariations.length;
          const { page_size, page } = pagination;
          const maxPage = Math.ceil(totalVariations / page_size);
          const newPage = Math.max(1, page > maxPage ? maxPage : page);

          const begin_of_page = (page - 1) * page_size;
          const end_of_page = Math.min(
            begin_of_page + page_size,
            totalVariations
          );
          setPagination({
            page_size: page_size,
            max_items: totalVariations,
            page: newPage,
            begin_of_page: totalVariations === 0 ? 0 : begin_of_page + 1,
            end_of_page: end_of_page,
          });
        }
      }
    });
  };

  const delete_variations = () => {
    setAllVariations((previous) =>
      previous.filter(
        (variation) => !selectedVariationIds.includes(variation.id)
      )
    );
    setSelectedVariationIds([]);
  };

  const handleAction = async (event) => {
    if (event === "generate-barcodes") {
      generate_barcodes();
    } else if (event === "delete-barcodes") {
      delete_barcodes();
    } else if (event === "delete") {
      delete_variations();
    }
  };

  const handleNewVariation = () => {
    const size = allSizes.filter(
      (size) => size.size_id === Number(addVariation.size)
    )[0];
    const color = allColors.filter(
      (color) => color.color_id === Number(addVariation.color)
    )[0];

    if (!size && !color) {
      ToastError("Je moet een maat of kleur selecteren");
      return;
    }
    if (
      allVariations.find(
        (e) => e.color_id == color?.color_id && e.size_id == size?.size_id
      )
    ) {
      ToastError("Die variatie bestaat al");
      return;
    }

    const newVariation = {
      id: allVariations.length > 0 ? Math.max(...allVariations.map(v => v.id)) + 1 : 1,
      size_id: size?.size_id ?? null,
      size_name: size?.main ?? null,
      color_id: color?.color_id ?? null,
      color_name: color?.name ?? null,
      hex: color?.hex ?? null,
      colors:
        color != null
          ? [
            {
              color_id: color?.color_id ?? null,
              name: color?.name ?? null,
              hex: color?.hex ?? null,
            },
          ]
          : [],
      sizes:
        size != null
          ? [
            {
              size_id: size?.size_id ?? null,
              name: size?.main ?? null,
            },
          ]
          : [],
      product_number: buildVariationProductNumber(getBaseProductNumber(), color?.name, size?.main),
    };
    const sizeVariation = {
      id: size?.size_id ?? null,
      name: size?.main ?? null,
    };
    const colorVariation = {
      id: color?.color_id ?? null,
      name: color?.name ?? null,
    };
    if (sizeVariation.id) {
      setSizeVariations([sizeVariation, ...sizeVariations]);
    }
    if (colorVariation.id) {
      setColorVariations([colorVariation, ...colorVariations]);
    }
    setAllVariations([newVariation, ...allVariations]);
  };

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleGendersChange = (event) => {
    const valueAsInt = parseInt(event.target.value, 10);

    if (event.target.checked) {
      setSelectedGenders([...selectedGenders, valueAsInt]);
    } else {
      setSelectedGenders(selectedGenders.filter((e) => e !== valueAsInt));
    }
  };

  const handleSalesChannelsChange = (event) => {
    const valueAsInt = parseInt(event.target.value, 10);

    if (event.target.checked) {
      setSelectedSalesChannels([...selectedSalesChannels, valueAsInt]);
    } else {
      setSelectedSalesChannels(
        selectedSalesChannels.filter((e) => e !== valueAsInt)
      );
    }
  };

  const handleBarcodeChange = (newBarcode, id) => {
    setAllVariations((prevVariations) =>
      prevVariations.map((variation) =>
        variation.id === id ? { ...variation, barcode: newBarcode } : variation
      )
    );

    if (allVariations?.length) {
      const totalVariations = allVariations.length;
      const { page_size, page } = pagination;
      const maxPage = Math.ceil(totalVariations / page_size);
      const newPage = Math.max(1, page > maxPage ? maxPage : page);

      const begin_of_page = (page - 1) * page_size;
      const end_of_page = Math.min(begin_of_page + page_size, totalVariations);

      const paginatedVariations = allVariations.slice(
        begin_of_page,
        end_of_page
      );
      setPagination({
        page_size: page_size,
        max_items: totalVariations,
        page: newPage,
        begin_of_page: totalVariations === 0 ? 0 : begin_of_page + 1,
        end_of_page: end_of_page,
      });
      setVariations(paginatedVariations);
    }
  };

  const handleStockChange = (newStock, variationId) => {
    setAllVariations((prevVariations) =>
      prevVariations.map((variation) =>
        variation.id === variationId
          ? { ...variation, stock: newStock }
          : variation
      )
    );
  };

  const handleVariationPriceChange = (value, variationId) => {
    const price = value;

    const productVariation = variations.find((v) => v.id === variationId);
    if (!productVariation) {
      console.error("No variation found for variationId:", variationId);
      return;
    }

    setAllVariations((prevVariations) =>
      prevVariations.map((variation) =>
        variation.id === variationId
          ? { ...variation, price: price }
          : variation
      )
    );
  };

  const handleVariationBuyInPriceChange = (value, variationId) => {
    const numVal = value ? String(value).replace(',', '.') : '';
    const inclTax = numVal
      ? (parseFloat(numVal) * (1 + (selectedTax || 0) / 100)).toFixed(2)
      : '';

    setAllVariations((prevVariations) =>
      prevVariations.map((variation) => {
        if (variation.id !== variationId) return variation;
        const existingPrices = variation.prices ?? [];
        const hasBuyIn = existingPrices.some((p) => p.type === 'buy_in_price');
        if (!numVal) {
          return { ...variation, prices: existingPrices.filter((p) => p.type !== 'buy_in_price') };
        }
        return {
          ...variation,
          prices: hasBuyIn
            ? existingPrices.map((p) => p.type === 'buy_in_price' ? { ...p, excl_tax: numVal, incl_tax: inclTax } : p)
            : [...existingPrices, { price_id: null, type: 'buy_in_price', excl_tax: numVal, incl_tax: inclTax }],
        };
      })
    );
  };

const focusedId=useRef();
const carrotRef= useRef();

  const columns = useMemo(() => {
    // Base columns
    const cols = [
      {
        Header: (
          <div className="d-flex justify-content-center align-items-center" style={{ width: '60px' }}>
            <RegularCheckBox
              label=""
              value={selectedVariationIds.length > 0 && selectedVariationIds.length === variations.length}
              setValue={(checked) => {
                setSelectedVariationIds(
                  checked ? variations.map((v) => v.id) : []
                );
              }}
            />
          </div>
        ),
        accessor: "select",
        width: 60,
        minWidth: 60,
        maxWidth: 60,
        Cell: ({ row }) => {
          const isSelected = selectedVariationIds.includes(row.original.id);
          return (
            <div className="d-flex justify-content-center align-items-center" style={{ width: '60px' }}>
              <RegularCheckBox
                label=""
                value={isSelected}
                setValue={(checked) =>
                  handleProductSelection(row.original.id, checked)
                }
              />
            </div>
          );
        },
      },
      ...(duplicateInstalled?.apps?.find(app => app.slug === "variabel-product-number")?.status === 3 ? [{
        Header: (
          <div className="d-flex justify-content-center align-items-center fw-bold">
            Artikelnummer
          </div>
        ),
        accessor: "product_number",
        width: 'auto',
        minWidth: 150,
        Cell: ({ row }) => {
          const variationId = row.original.id;
          const variationData = allVariations.find((v) => v.id === variationId) || {};
          const appInstalled =
            duplicateInstalled?.apps?.find(
              (app) => app.slug === "variabel-product-number"
            )?.status === 3;

          const [localArticle, setLocalArticle] = useState(
            variationData?.product_number ?? ""
          );
          const inputRef = useRef();
          const id = `${variationId}-article`;

          useEffect(() => {
            if (inputRef?.current && focusedId.current === id) inputRef.current.focus();
          }, [inputRef]);

          const updateArticle = () => {
            const newVal = String(localArticle || "").trim();
            const maxLen = 255;
            if (newVal.length > maxLen) {
              ToastError(`Artikelnummer mag maximaal ${maxLen} karakters bevatten`);
              return;
            }

            // only update if changed
            if (newVal === (variationData.product_number ?? "")) return;

            setAllVariations((prev) =>
              prev.map((variation) =>
                variation.id === variationId
                  ? { ...variation, product_number: newVal }
                  : variation
              )
            );

            // refresh pagination / visible rows
            if (allVariations?.length) {
              const totalVariations = allVariations.length;
              const { page_size, page } = pagination;
              const maxPage = Math.ceil(totalVariations / page_size);
              const newPage = Math.max(1, page > maxPage ? maxPage : page);

              const begin_of_page = (newPage - 1) * page_size;
              const end_of_page = Math.min(begin_of_page + page_size, totalVariations);

              const paginatedVariations = allVariations.slice(
                begin_of_page,
                end_of_page
              );
              setPagination({
                page_size: page_size,
                max_items: totalVariations,
                page: newPage,
                begin_of_page: totalVariations === 0 ? 0 : begin_of_page + 1,
                end_of_page: end_of_page,
              });
              setVariations(paginatedVariations);
            }
          };

          return (
            <div className="d-flex justify-content-center align-items-center">
                <div style={{ minWidth: '150px', maxWidth: '220px' }}>
                  <BorderedSquareTextInput
                    size="l"
                    placeholder="Artikelnummer"
                    inputValue={localArticle}
                    setInputValue={setLocalArticle}
                    updateFunction={updateArticle}
                    updateWaitTimer={null}
                    ref={inputRef}
                    onFocus={() => (focusedId.current = id)}
                    onBlur={() => (focusedId.current = null)}
                    useModifiedBlur={true}
                  />
                </div>
            </div>
          );
        }
      }] : []),
      {
        Header: (
          <div className="d-flex justify-content-center align-items-center fw-bold">
            Voorraad
          </div>
        ),
        accessor: "stock",
        width: 120,
        minWidth: 120,
        maxWidth: 120,
        Cell: ({ row }) => {
          const variationId = row.original.id;
          const variationData = allVariations.find((v) => v.id === variationId);
          const stockValue = variationData?.stock || "";
          const [localStock, setLocalStock] = useState(stockValue);
            const id = `${variationId}-stock`;

          const inputRef = useRef();
          useEffect(()=>{
            if(inputRef?.current&&focusedId.current===id)inputRef.current.focus();
          },[inputRef])

          const updateStock = () => {
            // Delay so that if =/- button get pressed it isn't canceld
            setTimeout(()=>{
            handleStockChange(localStock, variationId);
            },100)
          };

          return (
            <div
              className="d-flex justify-content-center align-items-center px-2"
            >
              <div style={{ width: '60px' }}>
                <BorderedSquareNumberInput
                size="l"
                placeholder="0"
                inputValue={localStock === 0 ? '' : localStock}
                setInputValue={setLocalStock}
                updateFunction={updateStock}
                updateWaitTimer={null}
                ref={inputRef}
                onFocus={() => focusedId.current=id}
                onBlur={() => focusedId.current=null}
                useModifiedBlur={true}
                />
              </div>
            </div>
          );
        },
      },
      ...(duplicateInstalled?.apps?.find(app => app.slug === "variable-purchase-price")?.status === 3 ? [{
        Header: (
          <div className="d-flex justify-content-center">Inkoop prijs</div>
        ),
        accessor: "buy_in_price",
        Cell: ({ row }) => {
          const variationId = row.original.id;
          const variationData = variations.find((v) => v.id === variationId);
          const buyInPrice = variationData?.prices?.find(p => p.type === 'buy_in_price')?.excl_tax ?? '';
          const productBuyInPrice = prices?.find(p => p.type === 'buy_in_price')?.excl_tax;
          const inputRef = useRef();
          const id = `${variationId}-buy-in-price`;
          const [localBuyIn, setLocalBuyIn] = useState(buyInPrice);

          useEffect(() => {
            if (inputRef?.current && focusedId.current === id) {
              inputRef.current.focus();
            }
          }, [inputRef]);

          useEffect(() => {
            if (focusedId.current !== id) {
              setLocalBuyIn(buyInPrice);
            }
          }, [buyInPrice]);

          const updateBuyIn = () => {
            setTimeout(() => {
              handleVariationBuyInPriceChange(localBuyIn, variationId);
            }, 100);
          };

          return (
            <div className="d-flex justify-content-center">
              <CurrencyInput
                placeholder={productBuyInPrice ? formatCurrency(productBuyInPrice) : '€ 0.00'}
                className="stockBox variablePriceBox px-2"
                decimalsLimit={2}
                prefix="€ "
                step={0.01}
                min={0}
                name={`${variationId}-buy-in`}
                value={localBuyIn !== '' ? localBuyIn : ''}
                onValueChange={(value) => {
                  setLocalBuyIn(value ?? '');
                }}
                formatValueOnBlur={false}
                onBlur={() => { focusedId.current = null; updateBuyIn(); }}
                onFocus={() => (focusedId.current = id)}
                ref={inputRef}
              />
            </div>
          );
        },
      }] : []),
      {
        Header: (
          <div className="d-flex justify-content-center align-items-center fw-bold" style={{ minWidth: '200px' }}>
            Barcode
          </div>
        ),
        accessor: "barcode",
        width: 'auto',
        minWidth: 200,
        Cell: ({ row }) => {
          const variationId = row.original.id;
          const variationData = allVariations.find((v) => v.id === variationId);
          const barcodeValue = variationData?.barcode || "";
          const [localBarcode, setLocalBarcode] = useState(barcodeValue);

          const inputRef = useRef();
          const id = `${variationId}-barcode`;
        
          useEffect(()=>{
            if(inputRef?.current&&focusedId.current===id)inputRef.current.focus();
          },[inputRef])

          const updateBarcode = () => {
            // Delay so that if =/- button get pressed it isn't canceled
            setTimeout(()=>{
              handleBarcodeChange(localBarcode, variationId);
            },100)
          };

          return (
            <div className="d-flex justify-content-center align-items-center gap-2 px-2">
              <confirmationModal
                title="Barcode overschrijven"
                message="Weet je zeker dat je de barcode van deze variatie wilt overschrijven?"
                confirmButtonText="Ja, overschrijf de barcode"
                cancelButtonText="Nee, behoud de barcode"
                onConfirm={() => handleBarcodeChange("", variationId)}
              />
              <div style={{ minWidth: '150px', maxWidth: '200px' }}>
                <BorderedSquareTextInput
                  size="s"
                  inputValue={localBarcode}
                  setInputValue={(Value)=>{
                    if(Value.length<=maxBarcodeLength)
                    setLocalBarcode(Value);
                  }}
                  updateFunction={updateBarcode}
                  updateWaitTimer={null}
                  onWheel={(e) => e.target.blur()}
                  ref={inputRef}
                  onFocus={() => focusedId.current=id}
                  onBlur={() => focusedId.current=null}
                  useModifiedBlur={true}
                />
              </div>
              <div
                className="d-flex justify-content-center align-items-center generateBarcodeBtn"
                onClick={(e) => generateBarcode(e, variationId)}
                style={{ cursor: 'pointer', minWidth: '30px' }}
              >
                <FontAwesomeIcon icon={faBarcode} />
              </div>
            </div>
          );
        },
      },
      ...(duplicateInstalled?.apps?.find(app => app.slug === "variable-product-price")?.status === 3 ? [{
        Header: (
          <div className="d-flex justify-content-center">Variabele prijs</div>
        ),
        accessor: "incl_tax",
        Cell: ({ row }) => {
          const variationId = row.original.id;
          const variationData = variations.find((v) => v.id === variationId);
          const operator = variationData?.priceOperator || null;
          const inputRef=useRef();

          const id = `${variationId}-price`;
        
          useEffect(() => {
            if (inputRef?.current && focusedId.current === id)
              inputRef.current.focus();
              if (carrotRef.current)
                inputRef.current.setSelectionRange(
                  carrotRef.current,
                  carrotRef.current
                );
          }, [inputRef]);
          return (
            <div className="d-flex justify-content-center gap-1">
              <div className="d-flex justify-content-center flex-row">
                <div
                  className={
                    operator === "+"
                      ? "VariationPriceBtnPlusSelected"
                      : "VariationPriceBtnPlus"
                  }
                  onClick={(e) => onPriceButtonClicked(e, variationId)}
                >
                  +
                </div>
                <div
                  className={
                    operator === "-"
                      ? "VariationPriceBtnMinusSelected"
                      : "VariationPriceBtnMinus"
                  }
                  onClick={(e) => onPriceButtonClicked(e, variationId)}
                >
                  -
                </div>
              </div>
              <CurrencyInput
                disabled={operator == null}
                placeholder="€ 0,00"
                className={`stockBox variablePriceBox px-2 ${
                  operator == null 
                    ? "disabled-input"
                    : ""
                }`}
                decimalsLimit={2}
                prefix="€ "
                step={.01}
                min={0}
                name={`${variationId}`}
                value={variationData.price ?? ""}
                onValueChange={(value) => {
                  carrotRef.current=inputRef.current.selectionStart===1?3:inputRef.current.selectionStart;
                  handleVariationPriceChange(value, variationId);
                }}
                formatValueOnBlur={false}
                onBlur={() => (focusedId.current = null)}
                onFocus={() => (focusedId.current = id)}
                ref={inputRef}
              />
            </div>
          );
        },
      }] : []),
      ...(duplicateInstalled?.apps?.find(app => app.slug === "variable-product-price")?.status === 3 ? [{
        accessor: "finalPrice",
        Cell: ({ row }) => {
          return (
            <div className="text-nowrap">
              <span className="align-self-center">
                = {formatCurrency(calculateFinalPrice(
                  variations.find((e) => e.id === row.original.id)
                ))}
              </span>
            </div>
          );
        },
      }] : []),
    ];

    // Add color column if color variations exist
    if (colorVariations.length > 0) {
      const uniqueColors = Array.from(
        new Map(colorVariations.map(color => [color.name, color])).values()
      );

      cols.splice(1, 0, {
        Header: (
          <div className="d-flex justify-content-center align-items-center">
            <select
              className="form-select form-select-sm fw-bold text-center"
              style={{ fontSize: '12px', borderRadius: '100px', minWidth: '120px' }}
              value={colorFilter}
              onChange={(e) => setColorFilter(e.target.value)}
            >
              <option value="">Filter kleur</option>
              {uniqueColors.map((color, index) => (
                <option key={index} value={color.color_id}>
                  {color.name}
                </option>
              ))}
            </select>
          </div>
        ),
        accessor: "color_name",
        width: 150,
        minWidth: 150,
        maxWidth: 150,
        Cell: ({ row }) => {
          return row.original.color_name ? (
            <div 
              className="d-flex justify-content-center align-items-center" 
            >
              <div
                className="rounded-circle me-2"
                style={{
                  backgroundColor: row.original.hex,
                  width: "15px",
                  height: "15px",
                  flexShrink: 0,
                }}
              />
              <div 
                className="text-nowrap text-truncate"
                style={{ maxWidth: '100px' }}
                title={row.original.color_name}
              >
                {row.original.color_name}
              </div>
            </div>
          ) : (
            <div style={{ width: '150px' }}></div>
          );
        },
      });
    }

    // Add size column if size variations exist
    if (sizeVariations.length > 0) {
      const insertIndex = colorVariations.length > 0 ? 2 : 1;
      const uniqueSizes = Array.from(
        new Map(sizeVariations.map(size => [size.id, size])).values()
      );

      cols.splice(insertIndex, 0, {
        Header: (
          <div className="d-flex justify-content-center align-items-center">
            <select
              className="form-select form-select-sm fw-bold text-center"
              style={{ fontSize: '12px', borderRadius: '100px', minWidth: '120px' }}
              value={sizeFilter}
              onChange={(e) => setSizeFilter(e.target.value)}
            >
              <option value="">Filter maat</option>
              {uniqueSizes.map((size, index) => (
                <option key={index} value={size.id}>
                  {size.main}
                </option>
              ))}
            </select>
          </div>
        ),
        accessor: "size_name",
        width: 100,
        minWidth: 100,
        maxWidth: 100,
        Cell: ({ row }) => {
          return (
            <div 
              className="d-flex justify-content-center align-items-center fw-medium" 
            >
              {row.original.size_name}
            </div>
          );
        },
      });
    }

    return cols;
  }, [
  selectedVariationIds,
  prices, 
  variations,
  colorVariations,
  sizeVariations,
  colorFilter,
  sizeFilter,
  ]);

  const tableInstance = useTable({ columns, data: variations });

  return (
    <PageTemplate
      navbarTitle={"Warehouse HUB"}
      pageIsLoading={isLoading}
      iconNavbar={NavbarIcon}
    >
      {submitting ||
        (!submitting && (
          <Modals
            show={show}
            openAddColor={addColorOpen}
            setOpenAddColor={setAddColorOpen}
            handleClose={() => {
              setShow(false);
              generateVariation();
            }}
            sizeId={localStorage.getItem("sizeId") ?? ""}
            selectedcolors={
              localStorage.getItem("colorsAddVariationCache")
                ? JSON.parse(
                    localStorage.getItem("colorsAddVariationCache")
                  ).reduce((acc, e) => {
                    acc[e.color_id] = e;
                    return acc;
                  }, {})
                : []
            }
          />
        ))}

      <ConfirmationModal
        showConfirmation={showGenerateConfirm}
        setShowConfirmation={setShowGenerateConfirm}
        acceptationFunction={() => {
          // Single-item generate
          if (pendingGenerateId) {
            performGenerateBarcode(pendingGenerateId);
            setPendingGenerateId(null);
            return;
          }

          // Bulk generate (user confirmed overwrite)
          if (pendingBulkGenerate && pendingBulkGenerateIds && pendingBulkGenerateIds.length) {
            performBulkGenerate(pendingBulkGenerateIds);
            setPendingBulkGenerate(false);
            setPendingBulkGenerateIds([]);
            return;
          }
        }}
        message={"Weet je zeker dat je de barcode wil overschrijven?"}
        acceptButtonText={"Ja, overschrijven"}
        cancelButtonText={"Nee, annuleren"}
      />

      <form
        onSubmit={submitNew}
        onKeyDown={handleFormKeyDown}
        method="post"
        className="d-flex justify-content-center minFitContent w-100"
      >
        <div className="mb-3 d-flex flex-column formItems  minFitContent w-100">
          <div className="d-flex justify-content-between mb-4 w-100 flex-wrap">
            <div className="d-flex gap-5 w-md-100 navigation-and-status">
              <BackButton
                text={"Terug"}
                disabled={false}
                onClickFunction={() => navigate("/producten"+window.location.search)}
              />
              {/* Published btn*/}
              <div className="d-flex flex-column align-items-center">
                {status ? (
                  <p className="mb-1 p-0">Gepubliceerd</p>
                ) : (
                  <p className="mb-1 p-0">Gearchiveerd</p>
                )}
                <label className="switchActiveProduct">
                  <input
                    type="checkbox"
                    checked={status}
                    onChange={(e) => setStatus(e.target.checked)}
                  />
                  <span className="sliderActiveProduct round"></span>
                </label>
              </div>
            </div>
            <div className="d-flex gap-3 CreateButtons w-md-100">
              <ButtonDarkBlue
                type="submit"
                disabled={allVariations.length === 0 || submitting}
                className="btn darkBlueStandardButton Nunito responsive-btn"
                onClickFunction={() => setbuttonPressed(1)}
                text={"Aanmaken en nieuwe toevoegen"}
              />
              {duplicateInstalled?.apps?.find(
                (app) => app.slug === "duplicate-products"
              )?.status === 3 ? (
                <ButtonDarkBlue
                  type="submit"
                  disabled={allVariations.length === 0 || submitting}
                  className="btn darkBlueStandardButton Nunito responsive-btn"
                  onClickFunction={() => setbuttonPressed(2)}
                  text={"Aanmaken en standaard waardes kopiëren"}
                />
              ) : null}
              <ButtonBlue
                type="submit"
                text={"Aanmaken"}
                onClickFunction={() => setbuttonPressed(3)}
                disabled={submitting || allVariations.length === 0}
                className="responsive-btn"
              />
            </div>
          </div>
          {submitting ? (
            <div className=" mb-4 d-flex align-items-center flex-column" role="alert">
              <div>
                <LoadingIcon color="#009fe3" size={80} />
              </div>
              Nieuw concept product wordt aangemaakt
            </div>
          ) : (
            <div className="d-flex flex-column flex-xxl-row justify-content-between">
              <div className="col-xxl-8 col-12">
                <div>
                  <div className="d-flex flex-column fitcontentHeight mb-4">
                    <FirstBox
                      handleChange={handleChange}
                      product={values}
                      setProduct={setValues}
                      brands={brands}
                      validate={validate}
                      setBrandId={setBrandId}
                      brandId={brandId}
                      edit={false}
                    />
                  </div>
                </div>
                <div className="whiteBox p-5 formVariationProduct mb-4">
                  <div className="d-flex justify-content-between align-items-baseline mb-2">
                    <h5 className="fw-semibold">Huidige variatie</h5>
                    <ButtonBlue
                      text="Pas aan/creëer variatie"
                      onClickFunction={() => setShow(true)}
                    />
                  </div>
                  <div className="widthColorTable">
                    {!isLoading ? (
                      <TablePreset
                        data={[
                          {
                            selectedIds: selectedIds,
                            tableInstance: tableInstance,
                            pagination: pagination,
                          },
                        ]}
                        tableLoading={isLoading}
                        setPagination={(e) => setPagination(e)}
                        handleSelection={handleSelection}
                        borderedDropDown={true}
                        actionOptions={[
                          {
                            title: "Genereer barcodes",
                            onClick: () => handleAction("generate-barcodes"),
                          },
                          {
                            title: "Verwijder barcodes",
                            onClick: () => handleAction("delete-barcodes"),
                          },
                          {
                            title: "Verwijder",
                            onClick: () => handleAction("delete"),
                          },
                        ]}
                        rightDropdowns={[
                          {
                            placeholder: "Selecteer een maat",
                            options: allSizes.map((size) => {
                              return {
                                title: size.main,
                                value: size.size_id,
                                onClick: () =>
                                  setAddVariation((prev) => ({
                                    ...prev,
                                    size: size.size_id,
                                  })),
                              };
                            }),
                            selectedValue: addVariation.size,
                          },
                          {
                            placeholder: "Selecteer een kleur",
                            options: allColors.map((color) => {
                              return {
                                title: color.name,
                                value: color.color_id,
                                onClick: () =>
                                  setAddVariation((prev) => ({
                                    ...prev,
                                    color: color.color_id,
                                  })),
                              };
                            }),
                            selectedValue: addVariation.color,
                          },
                        ]}
                        rightButtons={[
                          {
                            title: "Handmatig toevoegen",
                            function: handleNewVariation,
                          },
                        ]}
                      />
                    ) : (
                      <div className="table-container table-responsive">
                        <table>
                          <thead>
                            <tr>
                              <td>
                                <div>Loading</div>
                              </td>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    )}
                  </div>
                </div>

                {productMeasurementsInstalled && (
                  <div className="mt-4">
                    <ShippingInfoBox
                      product={values}
                      setProduct={setValues}
                      setUpdatedProduct={() => {}}
                    />
                  </div>
                )}

                <div className="my-4">
                  <MediaUploaderComponent
                    edit={false}
                    updatedMedia={true}
                    setUpdatedMedia={setUpdatedMedia}
                    setImages={setImages}
                    images={images}
                    useColors={true}
                    availableVariations={allVariations}
                    setCheck={setRequiredCheck}
                    product={product}
                    variationSwitch={variationSwitch}
                    setVariationSwitch={setVariationSwitch}
                  ></MediaUploaderComponent>
                </div>
              </div>
              <div className="d-flex flex-column flex-xxl-column col-12 col-xxl-4 sidebar-cards-container">
                {/* category */}
                <div className="col-12 col-xxl-12 mb-3 category-box-add-product">
                  <div className="">
                    {categories != null && categories.length ? (
                      <Categories
                        initialCategories={initialCategories}
                        setCheckedCategories={setCheckedCategories}
                        checkedCategories={checkedCategories}
                      />
                    ) : (
                      <div className="whiteBox boxCategories">
                        <div className="d-flex flex-column">
                          <div className=" widthBoxes w-100 p-3 categories">
                            <div className="d-flex justify-content-between flex-column">
                              <h5 className="inputTitle mb-3">Categorieën</h5>
                              <p>Er zijn geen categorieën gevonden</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* gender */}
                <div className="col-12 col-xxl-12 mb-3">
                <div className="whiteBox p-5 pb-2 pt-3">
                  <h5 className="inputTitle mb-3">Geslacht</h5>
                  <div>
                    {genders.map((gender, index) => (
                      <div key={index} className="d-flex flex-row mb-2">
                        <RegularCheckBox
                          label={gender.name}
                          value={selectedGenders.find(g => g === gender.gender_id) || false}
                          setValue={(checked) => {
                            const event = {
                              target: {
                                value: gender.gender_id,
                                checked: checked,
                              },
                            };
                            handleGendersChange(event);
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                </div>
                {/* seasons */}
                <div className="col-12 col-xxl-12 mb-3">
                  <div className="whiteBox p-5 pb-2 pt-3">
                    <h5 className="inputTitle mb-3">Seizoenen</h5>
                    <div className="scrollable-seasons-container">
                      {seasons.length === 0 ? (
                        <p className="text-muted">Geen seizoenen beschikbaar</p>
                      ) : (
                        seasons.map((season, index) => (
                          <div key={index} className="d-flex flex-row mb-2">
                            <RegularCheckBox
                              label={season.sub_season ? `${season.head_season} - ${season.sub_season}` : season.head_season}
                              value={selectedSeasons.includes(season.season_id)}
                              setValue={(checked) => {
                                if (checked) {
                                  setSelectedSeasons([...selectedSeasons, season.season_id]);
                                } else {
                                  setSelectedSeasons(selectedSeasons.filter(id => id !== season.season_id));
                                }
                              }}
                            />
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
                {/* prices */}
                <div className="col-12 col-xxl-12 mb-3">
                  <PriceBox
                    selectedTax={selectedTax}
                    setSelectedTax={setSelectedTax}
                    setTax={setTax}
                    refetch={refetch}
                    taxClass={taxClass}
                    setTaxClass={setTaxClass}
                    handleChange={handleChange}
                    prices={prices}
                    setPrices={setPrices}
                    priceMargin={priceMargin}
                    setPriceMargin={setPriceMargin}
                    validate={validate}
                    edit={false}
                    product={{ type: 2 }}
                    allVariations={allVariations}
                    setAllVariations={setAllVariations}
                    onTaxSettingsChangeCallback={(settings) => {
                      setSelectedTax(settings.currentTaxRate);
                      setTaxSettings(settings);
                    }}
                  />
                </div>

                <div className="col-6 col-xxl-12 pb-4">
                  <SalesChannelsBox
                    salesChannels={salesChannels}
                    handleSalesChannelsChange={handleSalesChannelsChange}
                    selectedSalesChannels={selectedSalesChannels}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </form>
    </PageTemplate>
  );
};
export default AddVariation;